import loadable from '@loadable/component';

import { IComparisonNotification } from '../../state/offersComparison';

export const ComparisonNotificationContainerLoadable = loadable<{ notification: IComparisonNotification }>(
  () => import('./ComparisonNotificationContainer'),
);
